var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-full-form-intro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row\">\n    <div class=\"g-loyalty-form__intro\">\n        <h2 class=\"c-loyalty__h2\">\n            ";
output += runtime.suppressValue((lineno = 3, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_sign-up-create-account-header"])), env.opts.autoescape);
output += "\n        </h2>\n        <p class=\"u-text-details c-loyalty__p\">\n            ";
output += runtime.suppressValue((lineno = 6, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_sign-up-create-account-text-1"])), env.opts.autoescape);
output += "\n            <a href=\"\" class=\"u-link--underlined js-loyalty-signin\" data-qa-loyalty-signin>\n                ";
output += runtime.suppressValue((lineno = 8, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_sign-in-link"])), env.opts.autoescape);
output += "\n            </a>\n        </p>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-full-form-intro.j2"] , dependencies)